// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__DniFq","box":"WorkspacesBox_box__10KD3","node":"WorkspacesBox_node__1pAVS"};